
export default {
    name: 'SvgAirlinesElectrical',
    props: {
        color: {
            type: String,
            default: '#615F5A',
        },
    },
};
